var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wheel-sidebar-bet",
      class: {
        "is-lost": !_vm.isWon && _vm.gameStatus === _vm.GameStatus.ENDED,
        "is-won": _vm.isWon,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "user-bet__color",
          class: "user-bet__color_" + _vm.WHEEL_MULTIPLIERS[_vm.bet.color],
        },
        [_vm._v(" " + _vm._s(_vm.WHEEL_MULTIPLIERS[_vm.bet.color]) + " ")]
      ),
      _c("div", { staticClass: "user-bet__info info" }, [
        _c("div", { staticClass: "info__earned" }, [
          _vm.isWon
            ? _c("div", { staticClass: "info__value" }, [
                _vm._v(
                  " " + _vm._s(_vm.formatCurrency(_vm.bet.totalWonUsd)) + " "
                ),
              ])
            : _c("div", { staticClass: "info__value" }, [
                _vm._v(
                  " " + _vm._s(_vm.formatCurrency(_vm.bet.itemsTotal)) + " "
                ),
              ]),
          _c("span", {
            staticClass: "user-bet__icon icon icon_arrow-up-rounded",
          }),
        ]),
        _vm.gameStatus === _vm.GameStatus.ENDED
          ? _c(
              "div",
              { staticClass: "info__congrats" },
              [
                _vm.isWon ? [_vm._v("您的收益")] : _vm._e(),
                !_vm.isWon ? [_vm._v("很遗憾")] : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]),
      _c(
        "button",
        {
          staticClass: "user-bet__control btn",
          class: {
            "is-lost": !_vm.isWon && _vm.gameStatus === _vm.GameStatus.ENDED,
            "is-won": _vm.isWon,
          },
          attrs: { type: "button" },
        },
        [
          _c(
            "div",
            { staticClass: "btn__text" },
            [
              _vm.gameStatus !== _vm.GameStatus.ENDED
                ? [_vm._v("进行中")]
                : _vm._e(),
              _vm.isWon ? [_vm._v("已获胜")] : _vm._e(),
              !_vm.isWon && _vm.gameStatus === _vm.GameStatus.ENDED
                ? [_vm._v("未中奖")]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }